import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './idb-performance-footer.css.lit';

import { OutlineElement } from '../../base/outline-element/outline-element';


/**
 * The IDB performance Container footer.
 * @element idb-performance-footer
 */
@customElement('idb-performance-footer')
export class IdbPerformanceFooter extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, attribute: 'main-text' })
  mainText: String = '';

  @property({ type: String, attribute: 'on-text' })
  onText: String = '';

  @property({ type: String, attribute: 'watch-text' })
  watchText: String = '';

  @property({ type: String, attribute: 'off-text' })
  offText: String = '';

  @property({ type: String, attribute: 'monitor-text' })
  monitorText: String = '';

  @property({ type: String, attribute: 'coming-soon-text' })
  comingSoonText: String = '';

  render(): TemplateResult {
    return html`
      <section class="legends">
        <span class="main-text">${this.mainText}</span>
        <ul>
          <li>
            <p>
              <span class="circle circle-green on-track">
                <idb-icon icon="check-circle" size="15px" color="currentColor" stroke-width="3"></idb-icon>
              </span> ${this.onText}
            </p>
          </li>
          <li>
            <p>
              <span class="circle circle-orange on-watch">
                <idb-icon icon="disc" size="15px" color="currentColor" stroke-width="3"></idb-icon>
              </span> ${this.watchText}
            </p>
          </li>
          <li>
            <p>
              <span class="circle circle-red off-track">
                <idb-icon icon="x-circle" size="15px" color="currentColor" stroke-width="3"></idb-icon>
              </span> ${this.offText}
            </p>
          </li>
          <li>
            <p>
              <span class="circle circle-gray monitor">
                <idb-icon icon="minus" size="15px" color="currentColor" stroke-width="3"></idb-icon>
              </span> ${this.monitorText}
            </p>
          </li>
          <li>
            <p>
              <span class="circle circle-blue coming-soon">
                <idb-icon icon="loader" size="15px" color="currentColor" stroke-width="3"></idb-icon>
              </span> ${this.comingSoonText}
            </p>
          </li>
        </ul>
      </section>
    `;
  }
}
